import { registerUserIdentity } from "@/api/custom";

export const setItemWithExpiry = (key: string, value: string, ttl: number) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getItemWithExpiry = (key: string) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const removeItemWithExpiry = (key: string) => {
  localStorage.removeItem(key);
};

export const setSessionStorageItemWithExpiry = (
  key: string,
  value: string,
  ttl: number,
) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};

export const getSessionStorageItemWithExpiry = (key: string) => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    sessionStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const removeSessionStorageItemWithExpiry = (key: string) => {
  sessionStorage.removeItem(key);
};

export const postAuth = async () => {
  let backoffIndex = 0;
  const runPostAuthenticationTasks = async () => {
    try {
      await startPostAuthenticationTasks();
      // store.dispatch({ kind: "cognitoAuth/setPostCompleted" });
    } catch (e) {
      // Fatal error has occurred, and should not proceed.
      console.error("Failed to complete post authentication tasks: ", e);
      if (backoffIndex === 0) {
        alert(
          "Failed to reach our server. Please check your internet connection and try again later.",
        );
      }
      setTimeout(
        runPostAuthenticationTasks,
        5000 * 2 ** backoffIndex + Math.random(),
      );
      backoffIndex += 1;
    }
  };
  setTimeout(runPostAuthenticationTasks, 1);
};

const startPostAuthenticationTasks = async () => {
  // const dispatch = store.dispatch;

  // Start but not awaited, non-essential tasks that
  // does not need to be completed before user sees
  // any content.
  const asyncTasks: Promise<void>[] = [
    registerUserIdentity(),
    // registerNotification(),
    // fetchConnectedBanks(),
  ];

  // Start and awaited; must be completed before dismissing loading UI
  const syncTasks: Promise<void>[] = [
    // loadKycStatus(),
    // loadApexStatus(store),
    // aprilCheckIfUserSignedUp(dispatch),
    // fetchInsuranceData(dispatch),
  ];

  Promise.all(asyncTasks);
  await Promise.all(syncTasks);
};
